import { useMutation } from '@tanstack/react-query';
import { uploadTemporalAttahedFile } from '@/postulation_form/services/api';

export const useFileUploadMutation = ({ onSuccess, onError, onPending, onHandleSubmitForm, t }) => {
  return useMutation({
    retry: 0,
    mutationFn: (payload) => uploadTemporalAttahedFile(payload),
    onMutate: (payload) => {
      onHandleSubmitForm(true);

      onPending({
        type: 'uploading',
        fileType: payload.fileType,
        filename: payload.fileContent.name,
        buttonUploader: payload.buttonUploader
      });
    },
    onSuccess: (requestData) => {
      const { success, file, fileType } = requestData;

      if (!success) {
        onError({
          type: 'INVALID_FILE',
          message: t('errors.invalid_file')
        });
        return;
      }

      const { originalName, tempPath } = file;
      onSuccess({
        filename: originalName,
        temporalFileName: tempPath,
        fileType
      });
    },
    onError: (error, variables) => {
      onError({
        type: 'GENERAL_ERROR',
        message: t('errors.general'),
        fileType: variables.fileType
      });
    },
    onSettled: () => {
      onHandleSubmitForm(false);
    }
  });
};
